<template>
  <div>
    <header class="m-header">
      <div class="m-header__translate">
        <div class="container-fluid">
          <div class="row text-right">
            <img style="cursor: pointer;" :class="[{'low-opacity': this.$i18n.locale !== 'pt' }]" :src="this.$config.imgDir + '/flag-brazil-32.png'" @click="setLocale('pt')">
            <img style="cursor: pointer;" :class="[{'low-opacity': this.$i18n.locale !== 'en' }]" :src="this.$config.imgDir + '/flag-usa-32.png'" @click="setLocale('en')">
          </div>
        </div>
      </div>
      <div class="m-header__logo">
        <div class="container">
          <div class="row">
            <div class="text-center m-info__title">
              <img :src="$config.logo">
            </div>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-inverse m-navbar">
        <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
          </div>
          <div id="navbar" class="navbar-collapse collapse m-navbar__collapse">
            <ul class="nav navbar-nav">
              <router-link :to="{ name: 'Homepage' }" tag="li" exact>
                <a><span>{{ $t("navbar.home") }}</span></a>
              </router-link>
              <router-link :to="{ name: 'ParksPage' }" tag="li" exact>
                <a><span>{{ $t("navbar.parks") }}</span></a>
              </router-link>
              <router-link :to="{ name: 'CompaniesPage' }" tag="li" exact>
                <a><span>{{ $t("navbar.companies") }}</span></a>
              </router-link>
              <router-link :to="{ name: 'AboutPage' }" tag="li" exact>
                <a><span>{{ $t("navbar.about") }}</span></a>
              </router-link>
              <router-link :to="{ name: 'ContactPage' }" tag="li" exact>
                <a><span>{{ $t("navbar.contact") }}</span></a>
              </router-link>
            </ul>
            <ul class="nav navbar-nav navbar-right">
              <li>
                <button class="btn navbar-btn btn-primary" @click="login()">{{ $t("navbar.login") }}</button>
              </li>
            </ul>
          </div><!--/.navbar-collapse -->
        </div>
      </nav>
    </header>
  </div>
</template>
<script>
  export default {
    name: 'Header',
    methods: {
      login () {
        this.$router.push({name: 'Login'})
      },
      setLocale (language) {
        this.$i18n.locale = language
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Header.vue?41956b96